import { render, staticRenderFns } from "./gallery-mobile-row.vue?vue&type=template&id=51a33ffe&"
import script from "./gallery-mobile-row.vue?vue&type=script&lang=js&"
export * from "./gallery-mobile-row.vue?vue&type=script&lang=js&"
import style0 from "./gallery-mobile-row.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports